import { createFileRoute } from "@tanstack/react-router";

import { staffSearchSchema } from "@/features/pracownicy/search";
import { StaffPage } from "@/features/pracownicy/staff-page";
import { ensureElementVisible, ensureSuperAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/pracownicy")({
	validateSearch: (search) => staffSearchSchema.parse(search),
	component: StaffPage,
	// D109: tylko super_admin (jak API modułu), także gdy ktoś w edytorze widoczności
	// nada element innej roli; element zostaje dla zgodności z pozycją menu.
	beforeLoad: async ({ context, location }) => {
		await ensureSuperAdminAccess();
		await ensureElementVisible(
			context.queryClient,
			"sidebar.konfiguracja.pracownicy",
			location.pathname,
		);
	},
});
